const safeDisplay = (id, value) => {
  const el = document.getElementById(id);
  if (el) el.style.display = value;
};

export const AbrirPruebas = () => {
  safeDisplay("pruebas", "block");
  safeDisplay("contenedorPruebas", "block");
  safeDisplay("sidebarNuevaSalida", "none");

  const columna1 = document.getElementById("columna1");
  if (columna1) {
    columna1.classList.remove("col-12");
    columna1.classList.add("col-9");
  }
};

export const CerrarPruebas = () => {
  safeDisplay("pruebas", "none");
  safeDisplay("contenedorPruebas", "none");
  safeDisplay("sidebarNuevaSalida", "block");

  const columna1 = document.getElementById("columna1");
  if (columna1) {
    columna1.classList.add("col-12");
    columna1.classList.remove("col-9");
  }
};


// export const AbrirPruebas = () => {
//   document.getElementById("pruebas").style.display = "block";
//   document.getElementById("contenedorPruebas").style.display = "block";

//   const columna1 = document.querySelector("#columna1");
//   const contenedorPruebas = document.querySelector("#contenedorPruebas");

//   if (columna1) {
//     columna1.classList.remove("col-12");
//     columna1.classList.add("col-9");
//   }
//   if (contenedorPruebas) {
//     document.getElementById("sidebarNuevaSalida").style.display = "none";
//   }
// };
// export const CerrarPruebas = () => {
//   document.getElementById("pruebas").style.display = "none";
//   document.getElementById("contenedorPruebas").style.display = "none";
//   const columna1 = document.querySelector("#columna1");
//   const contenedorPruebas = document.querySelector("#contenedorPruebas");

//   if (columna1) {
//     columna1.classList.add("col-12");
//     columna1.classList.remove("col-9");
//   }
//   if (contenedorPruebas) {
//     document.getElementById("sidebarNuevaSalida").style.display = "block";
//   }
// };
